<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      fullscreen
      :visible.sync="visible"
      width="900px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => cancel()"
      :modal-append-to-body="false"
      :modal="false"
    >
      <Main
        ref="main"
        :shipmentCode="shipmentCode"
        :chooseContainer="chooseContainer"
      />
      <span slot="footer">
        <el-button size="small" @click="cancel()">
          {{ $l('INDEX.btn_close') || '关闭' }}
        </el-button>
        <el-button
          type="warning"
          size="small"
          @click="saveBooking()"
          v-if="isAdd"
        >
          {{
            $l('INDEX.btn_saveandcreate_shipmentBooking') ||
              '保存并新建订舱记录'
          }}
        </el-button>
        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="confirm()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
    <ChooseBooking
      :title="
        $l('INDEX.btn_saveandcreate_shipmentBooking') || '保存并新建订舱记录'
      "
      :visible.sync="chooseBookingDialogOptions.visible"
      :data="chooseBookingDialogOptions.data"
      :shipmentCode="shipmentCode"
      @reload="reload()"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import ChooseBooking from '../choose-booking/dialog'
export default {
  components: { Main, ChooseBooking },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    shipmentCode: { type: String, default: '' },
    chooseContainer: { type: Boolean, default: true },
    isAdd: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      chooseBookingDialogOptions: {
        visible: false,
        data: {},
      },
    }
  },
  methods: {
    async confirm() {
      this.backDialogVisible = false
      const data = await this.$refs.main.getData()
      if (!data) return
      this.$emit('confirm', data)
      if (!this.chooseContainer) this.close()
    },
    async saveBooking() {
      const data = await this.$refs.main.getData()
      if (!data) return
      this.chooseBookingDialogOptions = { visible: true, data }
    },
    async cancel() {
      const { listBox } = await this.$refs.main.getData(false)
      if (!listBox || !listBox.length) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('update:visible', false)
      this.$emit('close')
      this.$emit('reload')
    },
    reload() {
      this.$refs.main.reload()
      this.$refs.main.reset()
    },
  },
}
</script>
